// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from folder-open.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FolderOpenIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.5 1a1.5 1.5 0 0 1 1.339.823l.056.125.018.052H13.5a1.5 1.5 0 0 1 1.473 1.215l.02.14L15 3.5l.001.633c.477.217.82.677.874 1.228l.008.153-.005.096L15 13.5a1.5 1.5 0 0 1-1.356 1.493L13.5 15h-11c-.78 0-1.42-.595-1.49-1.31l-.007-.135-.877-7.89A1.498 1.498 0 0 1 1 4.136V2.5a1.5 1.5 0 0 1 1.356-1.493L2.5 1h3ZM1.593 5l-.031.003a.5.5 0 0 0-.444.462l.002.09L2 13.5a.5.5 0 0 0 .41.492L2.5 14h11c.245 0 .45-.177.494-.449l.009-.106.878-7.904.002-.041a.5.5 0 0 0-.41-.492L14.383 5H1.593ZM5.5 2h-3a.5.5 0 0 0-.492.41L2 2.5V4h12v-.5a.5.5 0 0 0-.326-.469l-.084-.023L13.5 3h-7a.5.5 0 0 1-.492-.41L6 2.5a.5.5 0 0 0-.41-.492L5.5 2Z"
      />
    </svg>
  );
}
